/* eslint-disable max-len */
import React, { Component } from 'react';
import Phaser from 'phaser';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import config from './config';
import GameScene from './scenes/GameScene';
import PreloadScene from './scenes/PreloadScene';
import SiteScene from './scenes/SiteScene';

import ForwardButton from './RuleAndForwardButton/ForwardButton';
import Rule from './RuleAndForwardButton/Rule';
import Logo from '../PagesContainer/Logo';
import StartLogo from './StartLogo';
import bluePointsAnimationStates from '../PagesContainer/BluePointsBlock/animationStates';
import phaserComponentStates from './phaserComponentStates';

import pageParams from './pageParams';

export default class PhaserComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isGameSceneCreate: false,
            isGameProcess: false,
            isShowRule: false,
            isShowLogo: false,
            isShowForwardButton: false,
            isHideStartLogo: false,
        };

        this.handleShowLogoAndRule = this.handleShowLogoAndRule.bind(this);
        this.handleHideRule = this.handleHideRule.bind(this);
        this.handleForwardButtonClick = this.handleForwardButtonClick.bind(this);
        this.handleHideForwardButton = this.handleHideForwardButton.bind(this);
        this.handleShowStartLogoComplete = this.handleShowStartLogoComplete.bind(this);
        this.handleStartAnimation = this.handleStartAnimation.bind(this);
        this.handleHideStartLogoComplete = this.handleHideStartLogoComplete.bind(this);
        this.handleOnGameSceneCreate = this.handleOnGameSceneCreate.bind(this);
    }

    componentDidMount() {
        const { handleCloseGame, handleChangeBluePointsAnimation, phaserComponentState } = this.props;

        this.game = new Phaser.Game(Object.assign(config, { scene: [PreloadScene, GameScene, SiteScene] }));
        this.game.isForwardButtonClick = false;
        this.game.isShowStartLogoComplete = false;
        this.game.isHideStartLogoComplete = false;
        this.game.isRenderGame = phaserComponentState === phaserComponentStates.GAME;
        this.game.handleShowLogoAndRule = this.handleShowLogoAndRule;
        this.game.handleHideRule = this.handleHideRule;
        this.game.handleHideForwardButton = this.handleHideForwardButton;
        this.game.handleStartAnimation = this.handleStartAnimation;
        this.game.handleExitAnimation = () => {
            this.setState({ isGameProcess: false }, () => handleChangeBluePointsAnimation(bluePointsAnimationStates.TAKE_SITE_POSITION));
        };
        this.game.handleExitGame = () => {
            if (pageParams.screenSize === 's' || pageParams.screenSize === 'm') {
                this.game.destroy(true, true);
            } else {
                handleCloseGame(phaserComponentStates.SITE);
            }
        };
        // this.game.handleExitGame = () => this.game.destroy(true, true);
        // this.game.handleExitGame = () => handleCloseGame(phaserComponentStates.SITE);
        this.game.events.addListener('destroy', () => handleCloseGame(phaserComponentStates.HIDE));
        this.game.onGameSceneCreate = this.handleOnGameSceneCreate;
    }

    componentDidUpdate() {
        const { isChangePage, to } = this.props;

        if (isChangePage) this.game.to = to;
        this.game.isChangePage = isChangePage;
    }

    handleForwardButtonClick() {
        this.game.isForwardButtonClick = true;
    }

    handleHideRule() {
        const { isShowRule } = this.state;
        if (isShowRule) this.setState({ isShowRule: false });
    }

    handleHideForwardButton() {
        const { isShowForwardButton } = this.state;
        if (isShowForwardButton) this.setState({ isShowForwardButton: false });
    }

    handleShowLogoAndRule() {
        this.setState({ isShowLogo: true, isShowRule: true, isShowForwardButton: true });
    }

    handleStartAnimation() {
        const { handleChangeBluePointsAnimation } = this.props;
        handleChangeBluePointsAnimation(bluePointsAnimationStates.TAKE_MAZE_POSITION);
        this.setState({ isHideStartLogo: true });
    }

    handleShowStartLogoComplete() {
        this.game.isShowStartLogoComplete = true;
    }

    handleHideStartLogoComplete() {
        this.game.isHideStartLogoComplete = true;
        this.setState({ isGameProcess: true });
    }

    handleOnGameSceneCreate() {
        const { handleChangeBluePointsAnimation } = this.props;
        handleChangeBluePointsAnimation(bluePointsAnimationStates.START_SHOW);
        this.setState({ isGameSceneCreate: true });
    }

    render() {
        const {
            isGameSceneCreate,
            isGameProcess,
            isShowLogo,
            isShowRule,
            isShowForwardButton,
            isHideStartLogo,
        } = this.state;
        const { className, phaserComponentState } = this.props;

        return (
            <>
                <Container
                    className={className}
                    id="game-container"
                    isShowGame={phaserComponentState === phaserComponentStates.GAME}
                    isGameProcess={isGameProcess}
                />
                {
                    phaserComponentState === phaserComponentStates.GAME && (
                        <>
                            <StyledForwardButton
                                handleClick={this.handleForwardButtonClick}
                                isShow={isShowForwardButton}
                                isGameProcess={isGameProcess}
                            />
                            <StyledRule handleClick={this.handleForwardButtonClick} isShow={isShowRule} />
                            <StyledLogo isShow={isShowLogo} />
                            <StartLogo
                                offsetTop={pageParams.offsetTop}
                                offsetLeft={pageParams.offsetLeft}
                                isShow={isGameSceneCreate}
                                isHide={isHideStartLogo}
                                onShowComplete={this.handleShowStartLogoComplete}
                                onHideComplete={this.handleHideStartLogoComplete}
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const StyledLogo = styled(Logo)`
    position: absolute;

    will-change: opacity, transform;
    transition-property: opacity, transform;
    transition-duration: .5s;
    transition-timing-function: ease-in-out;
    opacity: ${({ isShow }) => (isShow ? 1 : 0)};
    transform: ${({ isShow }) => `translateY(${isShow ? 0 : -15}px)`};

    cursor: auto;
`;

const StyledRule = styled(Rule)`
    position: absolute;
    top: ${`${pageParams.offsetTop + 580}px`};
    left: ${`${pageParams.offsetLeft + 22}px`};

    will-change: opacity, transform;
    transition-property: opacity, transform;
    transition-duration: .5s;
    transition-timing-function: ease-in-out;
    opacity: ${({ isShow }) => (isShow ? 1 : 0)};
    transform: ${({ isShow }) => `translateY(${isShow ? 0 : 15}px)`};

    pointer-events: none;

    ${mediaWidth.m} {
        top: ${`${pageParams.offsetTop + 986}px`};
        left: ${`${pageParams.offsetLeft + 163}px`};
    };

    ${mediaWidth.l} {
        top: ${`${pageParams.offsetTop + 519}px`};
        left: ${`${pageParams.offsetLeft + 601}px`};
    };

    ${mediaWidth.xl} {
        top: ${`${pageParams.offsetTop + 682}px`};
        left: ${`${pageParams.offsetLeft + 736}px`};
    };
`;

const StyledForwardButton = styled(ForwardButton)`
    position: absolute;
    top: 34px;
    right: 16px;

    cursor: pointer;

    will-change: opacity, transform;
    transition-property: opacity, transform;
    transition-duration: .5s;
    transition-timing-function: ease-in-out;
    opacity: ${({ isShow }) => (isShow ? 1 : 0)};
    transform: ${({ isShow }) => `translateY(${isShow ? 0 : -15}px)`};

    z-index: ${({ isGameProcess }) => (isGameProcess ? 2 : 'auto')};

    ${mediaWidth.l} {
        top: 40px;
        right: 40px;
    };

    ${mediaWidth.xl} {
        top: 38px;
        right: 80px;
    };
`;

const Container = styled.div`
    /* width: 100%; */
    /* position: fixed; */
    /* position: ${({ isShowGame }) => (isShowGame ? 'fixed' : 'absolute')}; */
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    overflow: hidden;

    z-index: ${({ isGameProcess }) => (isGameProcess ? 1 : 'auto')};
`;
